<div class="dialog" [class.blocked]="isBlocked">
    <!-- Blocking overlay when external changes detected -->
    <div *ngIf="isBlocked" class="blocking-overlay">
        <div class="blocking-message">
            <icc-icon name="warning" class="warning-icon"></icc-icon>
            <p>{{ 'COMPLAINT_APPOINTMENT|Reklamacja została zmodyfikowana przez innego użytkownika. Dane w tym oknie są nieaktualne i zostały zablokowane do edycji. Zamknij okno i otwórz ponownie, aby zobaczyć aktualne dane.' | translate }}</p>
            <div class="blocking-actions">
                <button iccButton appearance="primary" (click)="reloadDialog()">
                    {{ 'INTERFACE|OK' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="dialog-header">
        <h3>{{ data.editMode ? ('COMPLAINT_APPOINTMENT|Dodawanie protokołu' | translate) : ('COMPLAINT_APPOINTMENT|Podgląd protokołu' | translate) }}</h3>
        <button
                [disabled]="signMode"
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">
            <div #target></div>

            <icc-complaint-appointment-protocol-edit
                [(complaint)]="data.complaint"
                [(complaintAppointment)]="data.appointment"
                [(editMode)]="data.editMode"
                [(complaintAppointmentAttachments)]="data.attachments"
                [(clientView)]="data.clientView"
                [(clientSigned)]="clientSigned"
                (addAttachmentToAppointment)="addAttachmentToAppointment()"
                (removeAttachmentToAppointment)="removeAttachmentToAppointment()"
            ></icc-complaint-appointment-protocol-edit>

            <div class="signatures">
                <div *ngIf="!data.editMode && data.appointment.clientSignatureImage" class="signature-container">
                    <h3>{{ 'COMPLAINT_APPOINTMENT|Podpis klienta' | translate }}</h3>
                    <img *ngIf="data.appointment.clientSignatureImage" [src]="data.appointment.clientSignatureImage" class="signature-image" alt="Podpis klienta" />
                    <p *ngIf="!data.appointment.clientSignatureImage">{{ 'COMPLAINT_APPOINTMENT|Brak podpisu klienta' | translate }}</p>
                </div>

                <div *ngIf="!data.editMode && data.appointment.servicemanSignatureImage" class="signature-container">
                    <h3>{{ 'COMPLAINT_APPOINTMENT|Podpis serwisanta' | translate }}</h3>
                    <img *ngIf="data.appointment.servicemanSignatureImage" [src]="data.appointment.servicemanSignatureImage" class="signature-image" alt="Podpis serwisanta" />
                    <p *ngIf="!data.appointment.servicemanSignatureImage">{{ 'COMPLAINT_APPOINTMENT|Brak podpisu serwisanta' | translate }}</p>
                </div>
            </div>

    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                *ngIf="(data.editMode && !data.clientView) || (!data.editMode && data.clientView)"
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ data.editMode ? ('INTERFACE|Anuluj' | translate) : 'INTERFACE|Zamknij' | translate }}
            </button>

            <button
                *ngIf="data.editMode && data.clientView"
                iccButton
                (click)="backToEditMode()"
                appearance="secondary"
                [disabled]="data.appointment.clientSignatureImage"
            >
                {{ 'INTERFACE|Wstecz' | translate}}
            </button>

            <button
                *ngIf="data.editMode && !data.clientView"
                iccButton
                (click)="proceedToClientView(); scrollToTarget(target)"
                [disabled]="!data.appointment.protocolChangedPartsOrActions || data.appointment.protocolChangedPartsOrActions.length < 10 || ((data.appointment.wingDamages || data.appointment.doorMeasurement) && !data.attachments.length)"
                appearance="primary"
            >
                {{ 'INTERFACE|Dalej' | translate}}
            </button>

            <div class="expandable-button" *ngIf="data.editMode && data.clientView && !data.appointment.servicemanSignatureImage">
                <button
                    iccButton
                    (click)="signDelivery()"
                    appearance="primary"
                >
                    {{ 'INTERFACE|Podpisz' | translate }}
                </button>
                <button
                    iccButton
                    appearance="primary"
                    [iccMenuTriggerFor]="signMenu"
                    [disabled]="!data.editMode || !data.clientView || data.appointment.clientSignatureImage || data.appointment.servicemanSignatureImage">
                    <icc-icon name="expand_more"></icc-icon>
                </button>
                <icc-menu #signMenu="iccMenu" xPosition="before" yPosition="below">
                    <button
                        *ngIf="data.editMode && data.clientView && !data.appointment.clientSignatureImage && !data.appointment.servicemanSignatureImage"
                        icc-menu-item
                        (click)="proceedWithoutClientSign()"
                    >
                        <span>{{ 'INTERFACE|Bez podpisu' | translate }}</span>
                    </button>
                </icc-menu>
            </div>

            <div *ngIf="!data.editMode && data.clientView" class="flex-horizontal">
                <span class="sync-indicator" [title]="'COMPLAINT_APPOINTMENT|Trwa zapisywanie na serwerze...' | translate">
                    <icc-icon *ngIf="synced !== 'synced'" name="file_synchronization"></icc-icon>
                </span>
                <div class="expandable-button">
                    <button iccButton appearance="primary" prefixIcon="email" [disabled]="synced !== 'synced' || isProcessingPdf || activeUserCompanyId !== data.appointment.assignedCompanyId || authorizedRetailerDistributorComplaint || distributorManufacturerComplaint" (click)="confirmSendingProtocol()">
                        {{ 'COMPLAINT_APPOINTMENT|Prześlij protokół do klienta' | translate }}
                    </button>
                    <button *ngIf="true" iccButton appearance="primary" [disabled]="synced !== 'synced'" [iccMenuTriggerFor]="appMenu">
                        <icc-icon name="expand_more"></icc-icon>
                    </button>
                    <icc-menu #appMenu="iccMenu" xPosition="before" yPosition="below">
                        <button icc-menu-item (click)="printAppointmentProtocolPdf()">
                            <span>{{ 'COMPLAINT_APPOINTMENT|Drukuj protokół' | translate }}</span>
                        </button>
                    </icc-menu>
                </div>
            </div>

        </div>
    </div>

</div>
<div
    *ngIf="!signMode"
    class="curtain"
    (click)="close()"
></div>
<div
    *ngIf="signMode"
    class="curtain"
></div>

<div id="sign-container"  *ngIf="signMode" cdkTrapFocus>
    <h4 *ngIf="!clientSigned">{{ 'COMPLAINT_APPOINTMENT|Podpis klienta' | translate }}</h4>
    <h4 *ngIf="clientSigned">{{ 'COMPLAINT_APPOINTMENT|Podpis serwisanta' | translate }}</h4>
    <div id="signature-pad-wrapper">
        <div *ngIf="mobileView && !isHorizontal" class="landscape__instruction">
            <h3>
                {{ 'COMPLAINT_APPOINTMENT|Zmień widok na poziomy' | translate }}
            </h3>
        </div>
        <h5 *ngIf="data.appointment.workStatus === 'completed' && !clientSigned">{{ 'COMPLAINT_APPOINTMENT|Potwierdzam usunięcie usterki i treść protokołu' | translate }}</h5>
        <h5 *ngIf="data.appointment.workStatus === 'inProgress' && !clientSigned">{{ 'COMPLAINT_APPOINTMENT|Potwierdzam treść protokołu serwisowego' | translate }}</h5>
        <h5 *ngIf="data.appointment.workStatus === 'rejected' && !clientSigned">{{ 'COMPLAINT_APPOINTMENT|Potwierdzam odrzucenie reklamacji i treść protokołu' | translate }}</h5>

        <canvas #signaturePad id="signature-pad"></canvas>
    </div>
    <div id="saving-info" *ngIf="saving === true">
        <p>{{ 'COMPLAINT_APPOINTMENT|Trwa zapisywanie...'| translate }}</p>
    </div>

    <div id="sign-buttons" *ngIf="!saving === true">
        <button
            *ngIf="!data.appointment.clientSignatureImage"
            iccButton
            appearance="secondary"
            data-test="delivery-sign-confirm"
            (click)="cancelSign()"
        >
            <icc-icon name="close"></icc-icon>
            {{ 'INTERFACE|Anuluj' | translate }}
        </button>
        <button
            iccButton
            appearance="secondary"
            data-test="delivery-sign-confirm"
            (click)="clearSign()"
            [disabled]="data.appointment.clientSignatureImage && data.appointment.servicemanSignatureImage"
        >
            <icc-icon name="delete"></icc-icon>
            {{ 'INTERFACE|Wyczyść' | translate }}
        </button>
        <div class="spacer"></div>
        <button
            iccButton
            appearance="primary"
            data-test="delivery-sign-confirm"
            (click)="saveSign()"
            [disabled]="data.appointment.clientSignatureImage && data.appointment.servicemanSignatureImage || isEmptySign()"
        >
            <icc-icon name="done"></icc-icon>
            {{ 'INTERFACE|Zatwierdź' | translate }}
        </button>
    </div>
</div>
